const MODES = {
    DEVELOP: 'develop',
    PRODUCTION: 'production'
}

export default MODES;
